import { styled } from '@mui/system'
import { fontSizes, colors, zIndex } from '../../Components/consts'
import { Tabs } from '../../Components/LazyComponents'
import { EAST_GRADIENT, WEST_GRADIENT } from '../../Constant'

export const VoteBackground = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: -1,
  background: colors.gray.gray90,
}))

export const RootVoteCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2),
  },
}))

export const VoteHeadSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: 1400,
  margin: theme.spacing(0, 2, 2),
}))

export const AllStarOuterCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: 1400,
  minWidth: '70%',
}))

type VoteProps = {
  playertype: 'east' | 'west'
}

export const ASVCon = styled('div')<VoteProps>(({ theme, playertype }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: theme.spacing(4),
  background: playertype === 'east' ? EAST_GRADIENT : WEST_GRADIENT,
  maxWidth: 1400,
  minWidth: '70%',
  [theme.breakpoints.down('md')]: {
    position: 'absolute',
    left: 10,
    right: 10,
  },
}))

export const SaveBar = styled('div')<{ addMargin?: boolean }>(
  ({ theme, addMargin = false }) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.allStarVoteEmailOverlay,
    background: `${colors.gray.gray20}95`,
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    borderTop: `1px solid ${colors.gray.gray40}`,
    [theme.breakpoints.down('sm')]: {
      height: 100,
    },
    '& .submitCon': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      margin: addMargin ? theme.spacing(5, 1, 5) : theme.spacing(5, 1, 1),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(3, 1),
      },
      '& .emailCon': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .error': {
        color: colors.red,
        display: 'inline-block',
        fontSize: fontSizes.small,
        lineHeight: 15,
        margin: theme.spacing(1),
      },
    },
    '& .subtextCon': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0, 2),
      '& .loginBtn': {
        textTransform: 'uppercase',
        textDecoration: 'underline',
        color: colors.darkBlue,
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        fontWeight: 800,
      },
      '& .subtext': {
        fontSize: fontSizes.small,
        fontWeight: 600,
        color: colors.black,
      },
    },
  })
)

export const PlayerTypeTabs = styled(Tabs)<VoteProps>(({ theme, playertype }) => ({
  width: '30%',
  background: playertype === 'east' ? EAST_GRADIENT : WEST_GRADIENT,
  borderRadius: theme.spacing(8),
  zIndex: 20,
  margin: theme.spacing(2, 0, -10, 0),
  [theme.breakpoints.down('sm')]: {
    width: '85%',
  },
  '& .MuiTabs-indicator': {
    background: colors.white,
  },
  '& .MuiTab-root': {
    color: colors.white,
    fontWeight: 700,
    textShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorPrimary': {
    color: colors.white,
    fontWeight: 700,
    textShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorPrimary.Mui-selected': {
    color: colors.white,
    fontWeight: 700,
    textShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
}))

type VoteTabProps = {
  playertype: 'east' | 'west'
  selected: boolean
}

export const VoteTabImg = styled('div')<VoteTabProps>(({ theme, selected }) => ({
  zIndex: 20,
  '& img': {
    width: 150,
    borderRadius: 6,
    opacity: selected ? 1 : 0.5,
    [theme.breakpoints.down('sm')]: {
      width: '45%',
    },
  },
}))

export const AvailSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '70vh',
  '& .availablePlayersCon': {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: theme.spacing(1, 0, 20, 0),
  },
  '& h3': {
    color: colors.gray.gray20,
  },
}))

export const DefaultPlayerCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 70,
  margin: theme.spacing(0, 4),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0, 2),
    width: 60,
  },
  '& .profileCon': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    '& .profile': {
      position: 'relative',
      height: 45,
      width: 45,
      background: `linear-gradient(135deg, ${colors.gray.gray20} 0%, ${colors.gray.gray60}60 100%)`,
      borderRadius: '50%',
      [theme.breakpoints.down('sm')]: {
        height: 30,
        width: 30,
      },
      '& .pos': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: fontSizes.semiLarge,
        color: colors.text,
        fontWeight: 700,
        [theme.breakpoints.down('md')]: {
          fontSize: fontSizes.medium,
        },
      },
    },
    '& .teamLogo': {
      height: 18,
      width: 18,
      objectFit: 'cover',
      zIndex: 9,
      marginLeft: '-10px',
      [theme.breakpoints.down('sm')]: {
        height: 15,
        marginLeft: '-8px',
      },
    },
  },
  '& .defaultName': {
    background: `linear-gradient(90deg, ${colors.gray.gray20} 0%, ${colors.gray.gray60}60 100%)`,
    height: 10,
    width: 45,
    borderRadius: 8,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      height: 7,
      width: 38,
    },
  },
}))

export const SelectedTeamCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(12, 0, 3, 0),
  '& .teamImg': {
    height: 120,
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      height: 60,
    },
  },
  '& .defaultTeamImg': {
    height: 120,
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      height: 100,
    },
  },
}))

export const SelectedList = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'space-around',
  },
}))

type ConferenceProps = {
  color: string
}
export const SelPosCon = styled('div')<ConferenceProps>(({ theme, color }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(1, 4),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(1, 2),
  },
  '& .posNameCol': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .posName': {
      fontSize: fontSizes.medium,
      color: color || colors.white,
      fontWeight: 'bold',
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
    '& .posNum': {
      fontSize: fontSizes.medium,
      marginLeft: 2,
      fontWeight: 'bold',
      color: color || colors.text,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
  },
  '& .selectedCon': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: 70,
    minWidth: '50%',
    '& .selectedItem': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 5,
      marginLeft: 5,
      '& .profileCon': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        maxWidth: 100,
        [theme.breakpoints.down('md')]: {
          maxWidth: 60,
        },
        '& .profile': {
          height: 45,
          borderRadius: '50%',
          [theme.breakpoints.down('md')]: {
            height: 30,
          },
        },
        '& .removeCon': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '50%',
          height: 20,
          width: 20,
          zIndex: 9,
          marginLeft: '-10px',
          background: `${colors.red}60`,
          [theme.breakpoints.down('sm')]: {
            height: 15,
            width: 15,
            marginLeft: '-8px',
          },
          '& .sign': {
            fontSize: fontSizes.medium,
            color: colors.white,
            fontWeight: 700,
            marginBottom: 2,
            cursor: 'pointer',
          },
        },
      },
      '& .name': {
        fontSize: fontSizes.small,
        fontWeight: 500,
        marginTop: 5,
        color: color || colors.text,
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.small,
        },
      },
    },
  },
}))

export const RemoveCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  height: 25,
  width: 25,
  background: `${colors.red}60`,
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    height: 20,
    width: 20,
  },
  '& .sign': {
    fontSize: fontSizes.medium,
    color: colors.white,
    fontWeight: 700,
    marginBottom: 2,
  },
}))
